import {
  AnalysisResultCategoryEnum,
  AnalysisResultModel,
  CheckResultEnum,
  VendorEnum,
} from '../../../shared/models';

export const filterAnalysisResults = <
  AnalysisResult extends Partial<AnalysisResultModel>,
  Category extends AnalysisResultCategoryEnum,
  Vendor extends VendorEnum,
  CheckResult extends CheckResultEnum,
>(
  analysisResults: AnalysisResult[] = [],
  {
    vendors,
    notVendors,
    results,
    categories,
  }: {
    vendors?: Vendor[];
    notVendors?: Vendor[];
    results?: CheckResult[];
    categories?: Category[];
  } = {},
): AnalysisResult[] => {
  return analysisResults.filter(
    (analysisResult) =>
      // Filter by vendor
      (vendors ? vendors.includes(analysisResult.vendor as Vendor) : true) &&
      (notVendors
        ? notVendors.includes(analysisResult.vendor as Vendor) === false
        : true) &&
      // Filter by result
      (results
        ? results.includes(analysisResult.result as CheckResult)
        : true) &&
      // Filter by category
      (categories
        ? categories.includes(analysisResult.category as Category)
        : true),
  );
};
